import React from 'react';

export default function Welcome({ onStart, onAdmin }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Hero photo piscine */}
      <div className="hero-section">
        <img src="/piscine.jpg" alt="La piscine" style={{ objectPosition: 'center 78%' }} />
        <div className="hero-overlay">
          <div style={{ color: '#fff', textShadow: '0 2px 8px rgba(0,0,0,0.5)' }}>
            <div style={{ fontSize: '0.85rem', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', opacity: 0.9, marginBottom: '0.25rem' }}>
              Gladys & Henry
            </div>
            <h1 style={{ fontSize: 'clamp(1.6rem, 6vw, 2.2rem)', fontWeight: 800, margin: 0, lineHeight: 1.15 }}>
              Tous à la Party-lunch<br />du 16 août !
            </h1>
          </div>
        </div>
      </div>

      {/* Contenu */}
      <div className="container px-3" style={{ maxWidth: 480, flex: 1, paddingTop: '1.5rem', paddingBottom: '2rem' }}>

        {/* Carte invitation */}
        <div className="party-card p-4 mb-3">
          <div className="d-flex align-items-start gap-3 mb-3">
            <span style={{ fontSize: '2rem' }}>📍</span>
            <div>
              <div style={{ fontWeight: 800, color: '#1a2e35', fontSize: '1rem' }}>Impasse Da Marguerite</div>
              <div style={{ color: '#607d8b', fontSize: '0.9rem' }}>Dimanche 16 août, à partir de 12h</div>
            </div>
          </div>
          <p style={{ color: '#37474f', fontSize: '0.95rem', lineHeight: 1.6, margin: 0 }}>
            La piscine et les fauteuils vous attendent pour un <strong>Party-lunch</strong> qui pourra s'éterniser autour de la piscine. N'oubliez pas vos lunettes de soleil, maillots de bain et bouées !
          </p>
        </div>

        {/* Carte photo terrasse */}
        <div className="party-card mb-3" style={{ overflow: 'hidden' }}>
          <img src="/terrasse.jpg" alt="La terrasse" style={{ width: '100%', height: '200px', objectFit: 'cover', objectPosition: 'center 30%' }} />
        </div>

        {/* Carte boissons */}
        <div className="party-card p-4 mb-4" style={{ background: 'linear-gradient(135deg, #e0f7fa, #f1f8e9)', border: '2px solid #b2ebf2' }}>
          <div className="d-flex align-items-center gap-2 mb-2">
            <span style={{ fontSize: '1.5rem' }}>🥂</span>
            <strong style={{ color: '#006064', fontSize: '1rem' }}>Participation Boissons</strong>
          </div>
          <p style={{ color: '#37474f', fontSize: '0.9rem', margin: 0, lineHeight: 1.5 }}>
            Pour que ce déjeuner soit plus festif, une participation « Boissons » sera la bienvenue. Aussi, pour confirmer sa venue, chaque adulte choisit sa participation.
          </p>
        </div>

        {/* Rappel date limite */}
        <div style={{ background: '#fff3e0', borderRadius: '0.75rem', padding: '0.75rem 1rem', marginBottom: '1.5rem', fontSize: '0.85rem', color: '#e65100' }}>
          <i className="bi bi-calendar-event me-2" />
          <strong>Réponse attendue avant le lundi 10 août</strong>
        </div>

        {/* Bouton principal */}
        <button className="btn btn-party w-100 mb-3" onClick={onStart}>
          Je participe ! 🎉
        </button>

        <div className="text-center">
          <button
            onClick={onAdmin}
            style={{ background: 'none', border: 'none', color: '#90a4ae', fontSize: '0.78rem', cursor: 'pointer', padding: '4px' }}
          >
            <i className="bi bi-gear me-1" />Administration
          </button>
        </div>
      </div>
    </div>
  );
}
